<template>
    <div class="">
        <Heading :title="$t('partners')" :routeName="'homepage'"></Heading>
        <div class="container mt-5 text-center">
            <a href="http://www.untrr.ro/">www.untrr.ro</a><br/>
            <a href="http://www.tachoweb.ro/">www.tachoweb.ro</a><br/>
            <a href="http://www.transmag.ro/">www.transmag.ro</a><br/>
            <a href="http://www.loimacron.eu/">www.loimacron.eu</a><br/>
            <a href="http://www.t-times.ro/">www.t-times.ro</a><br/>

            <a href="http://www.untrrplanner.ro/">www.untrrplanner.ro</a><br/>
            <a href="http://www.grsp.ro/">www.grsp.ro</a><br/>
            <a href="http://www.educatierutiera.ro/">www.educatierutiera.ro</a><br/>
            <a href="http://lutz.untrr.ro/">lutz.untrr.ro</a><br/>
            <a href="http://cmr.untrr.ro//">cmr.untrr.ro</a><br/>
        </div>
    </div>
</template>

<script>

import Heading from './snippets/Heading.vue'

export default {
    name: 'Partners',
    data: function() {
        return {
        };
    },
    components: {
        Heading
    },
    props: {
    },
    computed: {
    },
    mounted: function() {
    },
    methods: {
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.partners {
    a {
        display: inline-block;
        margin-right: 10px;
    }
}

</style>
